import React from "react";
import PropTypes from "prop-types";
import { Segmented, Select, Space } from "antd";
import EditStrategyTab from "./Modals/EditStrategyTab";
import CreateStrategyTab from "./Modals/CreateStrategyTab";

// One row: strategy group picker, enabled filter, and group edit/create.
// The selected group's description shows below it.
const StrategyTabsBar = (props) => {
  const {
    strategyTabs,
    getUserStrategyTabs,
    selectedStrategyTab,
    setSelectedStrategyTab,
    showEnabledStrategies,
    setShowEnabledStrategies,
  } = props;
  const selected = strategyTabs.find((tab) => tab.key === selectedStrategyTab);

  return (
    <div style={{ marginBlockEnd: 10 }}>
      <div className="flex flex-wrap items-center gap-3">
        <Select
          style={{ minWidth: 200 }}
          value={selectedStrategyTab}
          onChange={setSelectedStrategyTab}
          options={strategyTabs.map((tab) => ({
            label: tab.label,
            value: tab.key,
          }))}
        />
        <Segmented
          options={[
            { label: "All", value: null },
            { label: "Enabled", value: true },
            { label: "Disabled", value: false },
          ]}
          value={showEnabledStrategies}
          onChange={setShowEnabledStrategies}
        />
        <Space className="ml-auto">
          {selectedStrategyTab !== "all" && (
            <EditStrategyTab
              key={selectedStrategyTab}
              getUserStrategyTabs={getUserStrategyTabs}
              selectedStrategyTab={selected}
            />
          )}
          <CreateStrategyTab getUserStrategyTabs={getUserStrategyTabs} />
        </Space>
      </div>
      {selected?.children && <div className="pt-2">{selected.children}</div>}
    </div>
  );
};

StrategyTabsBar.propTypes = {
  strategyTabs: PropTypes.array,
  getUserStrategyTabs: PropTypes.func,
  selectedStrategyTab: PropTypes.any,
  setSelectedStrategyTab: PropTypes.func,
  showEnabledStrategies: PropTypes.bool,
  setShowEnabledStrategies: PropTypes.func,
};

export default StrategyTabsBar;
